<div class="customfields-page-header-spacer"></div>
	<div class="row customfields-page-header">
	<div class="form-group customfields-page-header-left-content customfields-page-header-truncate col-md-8 col-sm-8 col-xs-12">
	<h1 translate="Onvio.Core.Customfields.Title"></h1>
	</div>
	<div class="form-group customfields-page-header-right-content col-md-4 col-sm-4 col-xs-12">
	<button class="btn btn-primary"
			translate="Bluemoon.Practice.Common.Actions.Save"
			(click)="saveButtonClicked()">
	</button>
	<button class="btn btn-outline-primary"
			translate="Bluemoon.Practice.Common.Actions.Cancel"
			(click)="cancelButtonClicked()">
	</button>
	</div>
	</div>

	<div *ngIf="clientNavType === 'bentoNav'" id="menu" class="bento-tabset tabs-left">
		<ul ngbNav #nav="ngbNav" class="nav nav-tabs" [animation]="false" ngPreserveWhitespaces>
			<li [ngbNavItem]="client">
				<span id="client-tab-label" class="sr-only" translate="Onvio.Core.Customfields.Tab.Client"></span>
				<a  aria-labelledby="client-tab-label" ngbNavLink translate="Onvio.Core.Customfields.Tab.Client"></a>
				<ng-template ngbNavContent>
					<bmc-custom-fields class="col-md-8" [filters]="filters" [category]="'clients'"></bmc-custom-fields>
					<br/><br/>
				</ng-template>
			</li>
		</ul>
		<div [ngbNavOutlet]="nav" class="tab-content"></div>
	</div>

<div *ngIf="clientNavType === 'sideNav'" class="ng-bento sideNav-container">
	<bento-side-nav aria-label="Simple" class="sideNav" [items]="items"></bento-side-nav>
	<bmc-custom-fields class="col-md-8" [filters] = "filters" [category]="'clients'"></bmc-custom-fields>
</div>
